async function request(path, { method = 'GET', accessToken, body } = {}) {
	const response = await fetch(path, {
		method,
		credentials: 'omit',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${accessToken}`,
		},
		body: body ? JSON.stringify(body) : undefined,
	});
	const text = await response.text();
	const data = text ? JSON.parse(text) : null;
	if (!response.ok) {
		const message = (data && (data.message || data.error)) || `Request failed with status ${response.status}`;
		throw new Error(message);
	}
	return data;
}

const api = {
	listOldestPass(contactId, accessToken) {
		const params = new URLSearchParams({
			contact_id: contactId,
			sort: 'CREATED_DATE',
			order: 'ASC',
			size: '1',
		});
		return request(`/backoffice/v2/passes?${params}`, { accessToken });
	},
	getPassPlan(passPlanId, accessToken) {
		return request(`/backoffice/v2/pass_plans/${passPlanId}`, { accessToken });
	},
	getContact(contactId, accessToken) {
		return request(`/backoffice/v2/contacts/${contactId}`, { accessToken });
	},
	getWalletCommerceBalances(walletId, accessToken) {
		return request(`/backoffice/v2/wallets/${walletId}/commerce_balances`, { accessToken });
	},
	listPassRedemptionJournals(contactId, accessToken) {
		const params = new URLSearchParams({
			contact_id: contactId,
			event: 'PASS_REDEMPTION',
			size: '100',
		});
		return request(`/backoffice/v2/journals?${params}`, { accessToken });
	},
	listWalletPassRedemptionJournals(walletId, accessToken) {
		const params = new URLSearchParams({
			process: 'PASS_REDEMPTION',
			type: 'CREDIT',
			size: '100',
		});
		return request(`/backoffice/v2/wallets/${walletId}/journals?${params}`, { accessToken });
	},
	createWalletJournal(contactId, payload, accessToken) {
		return request(`/backoffice/v2/contacts/${contactId}/journals`, {
			method: 'POST',
			accessToken,
			body: payload,
		});
	},
};

export default api;
